import { sanitizeFileName } from '@helpers/sanitizeFileName';
import type { TUploadParams } from '@components/Files/UploadProvider/types/TUploadParams';
import type { TGenerateUploadParams } from './types/TGenerateUploadParams';

export async function fetchUploadParams(
  metaName: string,
  objectId: string,
  generateUploadParams: TGenerateUploadParams,
): Promise<TUploadParams> {
  const fileName = sanitizeFileName(metaName);
  const paramsFileName = encodeURIComponent(fileName);
  if (!objectId) {
    throw new Error('Wrong Job ID');
  }
  const { fields, url } = await generateUploadParams({ objectId, file: paramsFileName });

  return {
    fields,
    method: 'PUT',
    meta: {
      fileUrl: `https://${fields.bucket}.s3.amazonaws.com/${fields.key}`,
    },
    url,
  };
}
